
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFBE1B","d":"M100 0c55.2 0 100 44.8 100 100s-44.8 100-100 100S0 155.2 0 100 44.8 0 100 0z"}}),_c('g',{attrs:{"fill":"none","stroke":"#757474","stroke-width":"17","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M118.296 67.738c12.4 0 22.4 10 22.4 22.4s-10 22.5-22.4 22.5h-57.4"}}),_c('path',{attrs:{"d":"M92.396 81.138l-31.4 31.5 29.6 29.6"}})])])
          )
        }
      }
    